import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Button } from './button';

/** Cancelar / secondary — soft text button (modal surface is always light). */
export const ModalCancelButton = styled(Button).attrs({ variant: 'text' })`
  && {
    min-width: ${rem('96px')};
    padding: ${rem('8px')} ${rem('16px')};
    border-radius: ${rem('6px')};
    font-weight: 600;
    letter-spacing: 0.02em;
    background-color: transparent !important;
    box-shadow: none !important;
    transition: background-color 0.15s ease, color 0.15s ease;
    color: #64748b !important;

    &:hover {
      background-color: rgba(15, 23, 42, 0.06) !important;
      color: #475569 !important;
    }

    &:active {
      background-color: rgba(15, 23, 42, 0.1) !important;
      color: #334155 !important;
    }
  }
`;

const primaryActionBase = css`
  min-width: ${rem('110px')};
  padding: ${rem('8px')} ${rem('18px')};
  border-radius: ${rem('6px')};
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #ffffff !important;
  box-shadow: none !important;
  transition: background-color 0.15s ease, color 0.15s ease;
`;

/** Confirmar — Bootstrap success, white text (light + dark). */
export const ModalConfirmButton = styled(Button).attrs({ variant: 'contained' })`
  && {
    ${primaryActionBase}
    background-color: #28a745 !important;

    &:hover {
      background-color: #218838 !important;
      color: #ffffff !important;
      box-shadow: none !important;
    }

    &:active {
      background-color: #1e7e34 !important;
      color: #ffffff !important;
      box-shadow: none !important;
    }
  }
`;

/** Rechazar — Bootstrap danger, white text (light + dark). */
export const ModalRejectButton = styled(Button).attrs({ variant: 'contained' })`
  && {
    ${primaryActionBase}
    background-color: #dc3545 !important;

    &:hover {
      background-color: #c82333 !important;
      color: #ffffff !important;
      box-shadow: none !important;
    }

    &:active {
      background-color: #bd2130 !important;
      color: #ffffff !important;
      box-shadow: none !important;
    }
  }
`;

/** Continuar / primary — navy, white text (modal surface is always light). */
export const ModalPrimaryButton = styled(Button).attrs({ variant: 'contained' })`
  && {
    ${primaryActionBase}
    background-color: #04273f !important;

    &:hover {
      background-color: #031c2e !important;
      color: #ffffff !important;
      box-shadow: none !important;
    }

    &:active {
      background-color: #02131f !important;
      color: #ffffff !important;
      box-shadow: none !important;
    }
  }
`;

/** Cerrar — Bootstrap info, white text (light + dark). */
export const ModalCloseButton = styled(Button).attrs({ variant: 'contained' })`
  && {
    min-width: ${rem('96px')};
    padding: ${rem('8px')} ${rem('18px')};
    border-radius: ${rem('6px')};
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #ffffff !important;
    background-color: #17a2b8 !important;
    box-shadow: none !important;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
      background-color: #138496 !important;
      color: #ffffff !important;
      box-shadow: none !important;
    }

    &:active {
      background-color: #117a8b !important;
      color: #ffffff !important;
      box-shadow: none !important;
    }
  }
`;

/** Shared Paper sizing for success / endpoint response modals (white in light and dark). */
export const successModalPaperProps = {
  style: {
    minWidth: rem('420px'),
    maxWidth: rem('520px'),
    minHeight: rem('260px'),
    width: '100%',
    backgroundColor: '#ffffff',
    color: '#1e293b'
  }
};
